import ArrowDropDownFilled from '../../Icons/ArrowDropDownFilled';
export default function Select() {
    return {
        MuiSelect: {
            defaultProps: {
                IconComponent: ArrowDropDownFilled
            }
        }
    };
}
